<template>
  <div class="container">
    <b-row>
      <b-col cols="12" class="text-start">
        <h5>GL Codes</h5>
      </b-col>
    </b-row>
    <b-row>
      <b-col v-for="(item, index) in items" :key="index" cols="12" md="6" class="text-center mb-2">
        <div class="text-start">{{ item.chartOfAccountsTypeDescription }}</div>
        <p-advanced-select  
          data-type="chartOfAccounts"
          v-model="item.chartOfAccountsId"
          :filter="filterChartOfAccounts"
          :additionalFilterParameter="item"
          style="  display: block; width: 100%; max-height: 34px; padding-right: 10px; margin-bottom: 15px;"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
  export default {
    props: {
      items: {
        type: Array,
        required: true
      },
      fields: {
        type: Array,
        required: true
      }
    },
    methods: {
      filterChartOfAccounts(chartOfAccount, item) {
        return chartOfAccount.type === item.chartOfAccountsTypeDescription || chartOfAccount.type == null;
      }     
    }
  };
</script>

<style scoped>
  .container {
    margin-left: 40px;
    margin-right: 40px;
  }
  .text-center {
    text-align: center;
  }
  .text-start {
    text-align: left;
  }
</style>